<template>
    <div class="autocomplete-wrapper">
        <input
            class="form-control input-lg"
            type="text"
            @input="(e) => (search = e.target.value)"
            :value="search"
            @focus="showSuggestions = true"
            :placeholder="placeholder"
        />
        <ul class="autocomplete-suggestions" v-show="showSuggestions && matches.length > 0">
            <li v-for="(suggestion, index) in matches" :key="index" @click="onClick(suggestion.id)">
                <span>{{ suggestion[label] }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        suggestions: Array,
        placeholder: {
            type: String,
            default: 'Search...',
        },
        label: {
            type: String,
            default: 'title',
        },
    },
    data() {
        return {
            showSuggestions: true,
        };
    },
    mounted() {
        document.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.showSuggestions = false;
            }
        });
    },
    computed: {
        search: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        matches() {
            return this.filterSuggestions();
        },
    },
    methods: {
        filterSuggestions() {
            if (!this.search) {
                return [];
            }

            if (!this.showSuggestions) {
                this.showSuggestions = true;
                return [];
            }

            // Filter out records that don't contains this.search
            let results = this.suggestions.filter((suggestion) =>
                suggestion[this.label].toLowerCase().includes(this.search.toLowerCase())
            );

            return results.sort((a, b) => {
                // Sort by the record that has this.search closest to the start of this.label
                return a[this.label].toLowerCase().indexOf(this.search.toLowerCase()) <
                    b[this.label].toLowerCase().indexOf(this.search.toLowerCase())
                    ? -1
                    : 1;
            });
        },
        onClick(id) {
            let selected = this.suggestions.find((suggestion) => suggestion.id == id);

            this.search = selected[this.label];
            this.showSuggestions = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.autocomplete-wrapper {
    position: relative;

    input {
        width: 100%;
        padding: 10px 35px 10px 10px;
        font-size: 14px;
        border-radius: 5px;
        border: 0;
        box-shadow: 0 0 3px 1px #ddd;
        outline: none;
        background: url(https://objects.kaxmedia.com/auto/o/65618/06b713f9f9.svg) no-repeat 97%;

        &::placeholder {
            color: #777 !important;
        }
    }
}

.autocomplete-suggestions {
    width: max-content;
    min-width: 100%;
    padding: 0;
    border: 1px solid #c5c5c5;
    font-size: 14px;
    background: #ffffff;
    position: absolute;
    z-index: 10;
    overflow-y: hidden;

    li {
        cursor: pointer;
        margin-bottom: 0;

        span {
            display: block;
            font-size: 14px;
            padding: 3px 1em 3px 0.4em;
        }
    }
}
</style>
